import { todayTimeline } from '@/mocks/gossip';
import SectionHeading from './SectionHeading';

const tagColors: Record<string, string> = {
  娱乐圈: 'bg-primary-100 text-primary-700',
  社会: 'bg-accent-100 text-accent-700',
  科技: 'bg-secondary-100 text-secondary-700',
  影视: 'bg-primary-100 text-primary-700',
  体育: 'bg-accent-100 text-accent-700',
  财经: 'bg-accent-100 text-accent-700',
  游戏: 'bg-secondary-100 text-secondary-700',
};

export default function Timeline() {
  return (
    <section id="timeline" className="scroll-mt-20 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="今日汇总"
          title="一句话掌握今天大事"
          desc="按时间顺序梳理今日已经发酵的重点事件，让你在最短时间里补全今天的关键“剧情线”。"
          accentIcon="ri-time-line"
        />

        <div className="relative mt-8 rounded-2xl border border-background-200 bg-background-100/60 p-5 md:p-8">
          <ol className="relative grid grid-cols-1 gap-6 md:grid-cols-2">
            {todayTimeline.map((item, i) => (
              <li key={i} className="relative flex gap-4 pl-0">
                <div className="flex flex-col items-center">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-accent-300 bg-accent-50 text-xs font-bold text-accent-700">
                    {item.time.split(':')[1]}
                  </span>
                  {i < todayTimeline.length - 1 && (
                    <span className="mt-1 hidden h-full w-px bg-accent-200 md:block" />
                  )}
                </div>
                <div>
                  <span className={`inline-block rounded-full px-2 py-0.5 text-xs font-semibold ${tagColors[item.category] || 'bg-background-200 text-foreground-600'}`}>
                    {item.category}
                  </span>
                  <p className="mt-1.5 text-sm font-medium text-foreground-800">{item.content}</p>
                  <p className="mt-1 text-xs text-foreground-500">{item.time}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}